import React from "react";
import PropTypes from "prop-types";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";
import Button from "../../../../components/Button/Button";

const LeadTimeWarning = ({ show, onConfirm, onCancel }) => {
  return (
    <ConfirmationModal
      title="Expedited Shipping"
      show={show}
      onClose={onCancel}
      zIndex="tw-z-[200]">
      <p>
        The requested delivery date is less than 7 days, from tomorrow.
        Expedited shipping fees may apply.
      </p>
      <p>
        To continue, click OK or click Cancel to request a new date. If you have
        questions, please contact your Customer Service Representative.
      </p>

      <div className="tw-flex tw-flex-col- tw-gap-2 tw-mt-6">
        <Button
          brand="secondary"
          type="button"
          fullwidth="true"
          onClick={onConfirm}>
          OK
        </Button>
        <Button
          brand="primary"
          type="button"
          fullwidth="true"
          onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </ConfirmationModal>
  );
};

LeadTimeWarning.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default LeadTimeWarning;
